import React, {FC, ReactNode} from 'react';
import './style.scss';
import classNames from 'classnames';
import {IS_PLATFORM_IOS} from "../../services/utils/platforms";

interface IHeader {
    children: ReactNode,
    isContentCenter?: boolean,
    headerCompilations?: boolean
}

const Header: FC<IHeader> = ({
                                 children,
                                 isContentCenter,
                                 headerCompilations
                             }) => {
    return (
        <div className={classNames({
            "header": true,
            "header--ios": IS_PLATFORM_IOS,
            "header--compilations": headerCompilations,
            "header__content-center": isContentCenter,
        })}>
            {children}
        </div>
    )
};

export default Header;
